import Page from 'modules/Page/Container/index'
import React, { Fragment } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import AuthPage from 'routes/Components/AuthPage'
import { anonymous } from 'routes/config/user'

const AuthRouter = ({ isAuthenticated, permissions }) => {
  const location = useLocation()
  return (
    <Fragment>
      {location?.pathname?.includes('onboarding') ? (
        <Page isOnboarding={true}>
          <Routes>
            {anonymous?.map(({ routePath, Component }) => {
              return (
                <Route
                  key={routePath}
                  path={routePath}
                  element={<Component />}
                />
              )
            })}
          </Routes>
        </Page>
      ) : (
        <AuthPage isAuthenticated={isAuthenticated} permissions={permissions} />
      )}
    </Fragment>
  )
}

export default AuthRouter
